import React from 'react'
import withView from '../../../cmn/docAutomation/withView';
import SarasTrans from '../../../../library/notifications/SarasTrans';
import FormButton from '../../../../library/form/components/FormActionButton2';
import FormInput from '../../../../library/form/components/FormInput';
import FormLabel from '../../../../library/form/components/FormLabel'
import FormTitle from '../../../../library/form/components/FormTitle'
import { UiView, UiViewHeading, UiTitle, UiViewContent } from "../../../../library/layout/Index";


const WorkFlowHeader = (props) => {
    const { formObject, updateViewData } = props;

    const onSuccess = (action, containerKey, rKey, headerKey, response) => {
        if(updateViewData)updateViewData(response.mainViewData);
    }

    return (
        <UiView>
            <UiViewHeading>
                <UiTitle>
                    <span>
                        <FormTitle formObject={formObject} value='Select Workflow' />
                    </span>
                </UiTitle>
            </UiViewHeading>
            <UiViewContent>
                <span className="uiLbl">
                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "docType" }} value="Document Type" />
                </span>
                <FormInput formObject={formObject} rowKey="" className="uiVal"
                    action={{ InputType: "ac", paramName: "docType", acMethod: "DocumentType" }}
                />
                <FormButton formObject={formObject} ksc="t" rowKey=""
                    action={{ actionId: "refresh",  actionParam: { mode:"full", dtId: "#docType" }, onSuccess: onSuccess }}
                    className="uiActionButton" text={<SarasTrans value="Get WorkFlow" />}></FormButton>

                <span className="uiLbl" style={{ marginLeft: "25px" }}>
                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "workFlow" }} value="Work Flow" />
                </span>
                <FormInput formObject={formObject} rowKey="" className="uiVal"
                    action={{ InputType: "input", paramName: "workFlow" }}
                />
            </UiViewContent>
        </UiView>
    )
}

export default withView(WorkFlowHeader, "WorkFlowTmpl", "")